/* global io */
import ProjectService from '@/services/project';
import Parser from '@/services/parsers/index';
import fstore from '@/analytics/firestore';

const fetchSections = async ({ commit, dispatch, state }) => {
  const res = await ProjectService.fetchSectionData(state.adhocId);
  const sections = Object.values(res.data.section);
  commit('parseSectionData', sections);
  const neighbourhoodSection =
    sections.filter(section => section.section_name === 'Neighbourhood')[0];
  dispatch('neighbourhood/populateData', neighbourhoodSection, { root: true });
  const viewsSection =
    sections.filter(section => section.section_name === 'Views')[0];
  dispatch('floorplans/views/populateData', viewsSection, { root: true });
  const amenitiesSection =
    sections.filter(section => section.section_name === 'Amenities')[0];
  dispatch('amenities/populateData', amenitiesSection, { root: true });

    const builderSection =
      sections.filter(section => section.section_name === 'Builder Story')[0];
    dispatch('builder/populateData', builderSection, {
      root: true
    });

  fstore.init();
};

const initSocket = ({ state, rootState, commit, dispatch }) => {
  if (!state.hasAvailabilty) return;
  // const socket = io.connect('https://aws.adhocstudio.ca');
  // socket.on('connect', () => {
  //   socket.emit('joinProject', state.awsId);
  // });
  //
  // const updateUnitFromSocket = (payload) => {
  //   commit('floorplans/updateUnitsStatus', payload, { root: true });
  // };
  //
  // socket.on('unitUpdate', updateUnitFromSocket);
  // setInterval(() => {
  //   socket.emit('clientPing');
  // }, 20000);

  setInterval(() => {
    if (rootState.ui.isIdle) {
      dispatch('floorplans/fetchFloorplans', null, { root: true });
    }
  }, 5 * 60 * 1000, this);
};

const fetchSettings = async ({ commit, state }) => {
  const res = await ProjectService.fetchSettings(state.awsId);
  const data = Parser.adhocParser.parseSettings(res.data);
  commit('applySettings', data);
  commit('project/theme/applyTheme', data.theme, { root: true });
};

export default {
  fetchSections,
  initSocket,
  fetchSettings
};



// WEBPACK FOOTER //
// ./src/store/modules/project/actions.js